export default __webpack_public_path__ + "static/media/lock.bea5acbd.svg";